var imageWithTextSlider = new Swiper('.recommended-products-eleven .swiper-container', {
    slidesPerView: 1.2,
    loop: false,
    spaceBetween: 30,
    breakpoints: {  
        480: {
          slidesPerView: 2
        },
        900: {
          slidesPerView: 3.3,
          spaceBetween: 60,
        }
    },
    pagination: {
        el: ".swiper-pagination",
        type: "progressbar",
    },
    navigation: {
        nextEl: '.swiper-button-next',
        prevEl: '.swiper-button-prev',
	},
});